import Phaser from "phaser";
import config from "./config";
import GameScene from "./scenes/Game";
import PreloadScene from "./scenes/Preload";
import BlankScene from "./scenes/Blank";
import MobileGameControls from "./components/mobile-game-controls";
import Menu from "./components/menu";
import React, { useEffect, useState } from "react";
import Web3 from "web3/dist/web3.min.js";
import web3Config from "./web3-config";
import { Amplify } from "aws-amplify";
import awsExports from "./utils/auth/aws-exports";
import "@aws-amplify/ui-react/styles.css";
import { useAuth } from "./utils/auth/AuthDetails";
import AuthBNB from "./components/wod/AuthBNB";
import ForgotPasswordBNB from "./components/wod/ForgotPassword/ForgotPasswordBNB";
import ResetPassword from "./components/wod/ResetPassword/ResetPassword";
import PlayerCreationBNB from "./components/wod/PlayerCreation/PlayerCreationBNB";
import { Navigate } from "react-router-dom";
import LandingScreen from "./components/wod/LandingScreen/LandingScreen";
import Toast from "./components/Toast";
import { useQuery } from "@apollo/client";
import { GET_PLAYER } from "./components/wod/Dashboard.schema";

// ===== start mobile game controller =====

const mobileGameController = {
  isDown: { UP: false, LEFT: false, RIGHT: false },
  justDown: { UP: false, LEFT: false, RIGHT: false },
};
mobileGameController.getIsDown = (key) => {
  return mobileGameController.isDown[key];
};
mobileGameController.getJustDown = (key) => {
  let justDown =
    mobileGameController.justDown[key] && mobileGameController.getIsDown(key);
  mobileGameController.justDown[key] = false;
  return justDown;
};
mobileGameController.setKeyPressed = (key, pressed) => {
  mobileGameController.justDown[key] = pressed;
  mobileGameController.isDown[key] = pressed;
};

window.mobileGameController = mobileGameController;
// ===== end mobile game controller =====

// ==== start reposition mobile controls interval ====

function clearRepositionInterval() {
  try {
    // console.log('clearRepositionInterval()')
    clearInterval(window.__repositionControlsInterval);
  } catch (e) {
    console.warn(e);
  }
}

function setRepositionInterval() {
  try {
    clearRepositionInterval();

    // console.log('setRepositionInterval()')

    window.__repositionControlsInterval = setInterval(() => {
      try {
        // console.log('tryRepositioningMobileControls()')
        if (typeof window.repositionControls === "function") {
          window.repositionControls();
        }
      } catch (e) {
        console.warn(e);
      }
    }, 3000);
  } catch (e) {
    console.warn(e);
  }
}

try {
  setRepositionInterval();
} catch (e) {
  console.warn(e);
}

// ==== end reposition mobile controls interval ====

// startGame()

// window.web3 = null;
window.isConnected = false;

async function connectWallet() {
  if (window.ethereum) {
    window.web3 = new Web3(window.ethereum);
    try {
      await window.ethereum.enable();
      window.isConnected = true;
      // console.log("Connected")
      return true;
    } catch (e) {
      console.error(e);
      throw new Error("Cannot Connect Wallet: User denied wallet connection.");
    }
  } else if (window.web3) {
    window.web3 = new Web3(window.web3.currentProvider);
    window.isConnected = true;
    // console.log("Connected to old web3")
    return true;
  } else {
    throw new Error("No web3 detected.");
  }
}

const TOAST_TIMEOUT = 4000;

function App() {
  const [isGameOn, setisGameOn] = useState(false);
  const [selectedLevel, setselectedLevel] = useState(1);
  const [selectedCat, setselectedCat] = useState(1);
  const [username, setusername] = useState("");
  const [areGameSoundsOn, setareGameSoundsOn] = useState(true);
  const [bestScores, setbestScores] = useState([]);
  const [leaderboardScore, setleaderboardScore] = useState(null);
  const [leaderboard, setleaderboard] = useState([]);
  const [usernameInputDisabled, setusernameInputDisabled] = useState(false);
  const [isConnected, setisConnected] = useState(false);
  const [signature, setsignature] = useState(null);
  const [isAddingUsername, setisAddingUsername] = useState(false);
  const [lastUnlockedLevel, setlastUnlockedLevel] = useState(1);
  const [lastToastId, setlastToastId] = useState(0);
  const [toasts, settoasts] = useState([]);
  const [fireAppcontent, setFireAppContent] = useState(false);
  const [wallet, setWallet] = useState();
  const [isBnb, setisBnb] = useState(false);
  const [isBnbSuccess, setisBnbSuccess] = useState(false);
  const [isstartGame, setisstartGame] = useState(false);
  const [syncStatus, setsyncStatus] = useState("initial");

  Amplify.configure(awsExports);

  function UnAuthenticatedContent() {
    setFireAppContent(false);

    // return (
    //   <React.Fragment>
    //     <Navigate to="/" />
    //   </React.Fragment>
    // );
  }

  const AppContent = () => {
    const { isLoading, isAuthenticated, playerId } = useAuth();

    useEffect(() => {
      if (!isLoading || !isAuthenticated || !playerId) {
        setFireAppContent(false);
      }
    }, [isLoading, isAuthenticated, playerId]);

    if (isLoading) {
      return <LandingScreen />;
    }

    if (isAuthenticated) {
      if (!playerId) {
        console.log("no player id");
        // return (
        //   <React.Fragment>
        //     <Navigate to="/player" />
        //   </React.Fragment>
        // );
      }

      // return (
      //   <React.Fragment>
      //     <Navigate to="/" />
      //   </React.Fragment>
      // );
    }

    // return <UnAuthenticatedContent />;
  };

  const {
    data,
    refetch: refetchPlayer,
    loading: loadingPlayer,
  } = useQuery(GET_PLAYER, {
    fetchPolicy: "network-only",
  });

  const { email, logout } = useAuth();

  const showAlert = (msg) => {
    let lastToastId2 = lastToastId + 1;
    let toasts2 = [{ message: msg, id: lastToastId2 }].concat(toasts);
    // console.log(toasts2, toasts)
    settoasts(toasts2);
    setlastToastId(lastToastId2);

    setTimeout(() => hideAlert(lastToastId2), TOAST_TIMEOUT);
    return lastToastId2;
  };
  // console.log(toasts, lastToastId);

  const hideAlert = (id) => {
    let toasts2 = toasts.filter((item) => item.id !== id);
    settoasts(toasts2);
  };
  function startGame2() {
    // console.log('startGame()')
    new Phaser.Game(
      Object.assign(config, {
        scene: [PreloadScene, GameScene, BlankScene],
      })
    );
  }
  const loadScores = async () => {
    let coinbase;
    try {
      // window.web3 = new Web3(window.ethereum);
      coinbase = await window.web3.eth.getCoinbase();
    } catch (e) {
      console.warn(e);
    }
    if (!coinbase) return;

    let response = await fetch(`/api/scores-of?address=${coinbase}`).catch(
      (e) => {
        console.log(e);
      }
    );

    let json = await response.json();
    let bestScores2 = json.bestScores;
    let leaderboardScore = json.leaderboardScore;
    let lastUnlockedLevel2 = lastUnlockedLevel;

    for (let item of bestScores2) {
      if (item.level_completed && item.level >= lastUnlockedLevel2) {
        lastUnlockedLevel2 = item.level + 1;
      }
    }

    bestScores2 = bestScores2.sort((a, b) => b.level - a.level);

    setbestScores(bestScores2);
    setleaderboardScore(leaderboardScore);
    setlastUnlockedLevel(lastUnlockedLevel2);

    if (leaderboardScore && leaderboardScore.username) {
      setusername(leaderboardScore.username);
      setusernameInputDisabled(true);
    }
  };

  const loadLeaderboardData = async () => {
    let leaderboard2 = leaderboard;
    try {
      leaderboard2 = await (await fetch("/api/leaderboard")).json();
    } catch (e) {
      console.warn(e);
    }
    leaderboard2 = leaderboard2.sort((a, b) => b.score - a.score);
    setleaderboard(leaderboard2);
  };

  const handleConnectWallet = async () => {
    if (signature !== null) return;
    try {
      let isConnected = await connectWallet();
      setisConnected(isConnected);

      let coinbase = await window.web3.eth.getCoinbase();
      if (coinbase) {
        setWallet(coinbase);
        // setisConnected(true);
      } else {
        setWallet();
        // setisConnected(false);
      }

      localStorage.setItem("logout", "false");
      await handleSignature();
      if (isBnb === true) {
        setisBnbSuccess(true);
      }
    } catch (e) {
      showAlert("Error: " + (e.message || "Something went wrong"));
    }
  };

  const handleSignature = async () => {
    // window.web3 = new Web3(window.ethereum);
    let coinbase = await window.web3.eth.getCoinbase();
    let signature = await window.web3.eth.personal.sign(
      web3Config.METAMASK_MESSAGE,
      coinbase
    );
    setsignature(signature);
    setusername(String(data?.getPlayer?.displayName).trim().toLowerCase());

    //We need to create this global variables here because in useEffect we are updating the score and also
    //the updateScore is globally created in the Main App.js in order to be accesed from other components
    window.username = () => {
      return String(data?.getPlayer?.displayName).trim().toLowerCase();
    };
    window.signature = () => {
      return signature;
    };

    loadScores();
    // if (isstartGame === true) {
    //   startGame();
    // }
  };

  const isNftHolder = async () => {
    try {
      // window.web3 = new Web3(window.ethereum);
      let wallet = await window.web3.eth.getCoinbase();
      let contract = new window.web3.eth.Contract(
        web3Config.NFT_ABI,
        web3Config.NFT_ADDRESS
      );
      let nftBalance = await contract.methods.balanceOf(wallet).call();

      let stakingContract = new window.web3.eth.Contract(
        web3Config.STAKING_ABI,
        web3Config.STAKING_ADDRESS
      );

      let stakingContract_cawspremium = new window.web3.eth.Contract(
        web3Config.CAWS_PREMIUM_STAKING_ABI,
        web3Config.CAWS_PREMIUM_STAKING_ADDRESS
      );

      let stakingContract_cawswod = new window.web3.eth.Contract(
        web3Config.CAWS_WOD_STAKING_ABI,
        web3Config.CAWS_WOD_STAKING_ADDRESS
      );
      let nftStaking = await stakingContract.methods
        .depositsOf(wallet)
        .call()
        .catch((e) => {
          console.error(e);
        });

      let nftStaking_cawspremium = await stakingContract_cawspremium.methods
        .depositsOf(wallet)
        .call()
        .catch((e) => {
          console.error(e);
        });

      let nftStaking_cawswod = await stakingContract_cawswod.methods
        .depositsOf(wallet)
        .call()
        .catch((e) => {
          console.error(e);
        });
      if (
        Number(nftBalance) > 0 ||
        nftStaking.length > 0 ||
        nftStaking_cawspremium.length > 0 ||
        nftStaking_cawswod.length > 0
      ) {
        return true;
      } else if (
        Number(nftBalance) === 0 &&
        nftStaking.length === 0 &&
        nftStaking_cawspremium.length === 0 &&
        nftStaking_cawswod.length === 0
      ) {
        return false;
      }
    } catch (e) {
      console.warn(e);
      return false;
    }
  };

  const addUsername = async () => {
    setisAddingUsername(true);

    // let username2 = String(data?.getPlayer?.displayName).trim().toLowerCase();

    const updateLeaderboardAlertId = showAlert("Starting Game...");

    try {
      let isNftHolder2 = await isNftHolder();
      if (isNftHolder2 === false) {
        console.log("You must hold DYP CAWS NFT to play.");
        showAlert("Error: You must hold DYP CAWS NFT to play.");
        return;
      }

      let response = await fetch("/api/add-username", {
        method: "POST",
        body: JSON.stringify({
          username,
        }),
        headers: {
          "content-type": "application/json; charset=UTF-8",
          "auth-token": signature,
        },
      });

      let responseText = await response.text();
      let responseJson;
      try {
        responseJson = JSON.parse(responseText);
      } catch (e) {
        // console.warn(e)
      }
      if (!responseJson) {
        if (responseText !== "OK") {
          console.log("Error: ", responseText);
          showAlert("Error: " + responseText);
          return false;
        } else {
          // this.showAlert("Leaderboard updated.")
        }
      } else if (responseJson.status !== "success") {
        console.log("Error", responseJson.msg);
        showAlert("Error: " + responseJson.msg);
        return false;
      } else {
        // this.showAlert('Leaderboard updated.')
      }

      // console.log({ responseText })

      return true;
    } catch (e) {
      console.warn(e);
    } finally {
      setisAddingUsername(false);

      hideAlert(updateLeaderboardAlertId);
    }
  };

  const updateScore = async (
    level,
    score,
    completed = false,
    a = {},
    b = {},
    c = 0
  ) => {
    // let username2 = String(data?.getPlayer?.displayName).trim().toLowerCase();
    // console.log("test")
    // console.log(a)
    // console.log("test 2222")
    // console.log(b)

    const m = { 2: "a", 1: "b", 4: "c", 0: "d" };

    let f = a.f;

    function cc(c, obj) {
      let retStr = c.toString();

      for (let x in obj) {
        let v = Math.round(Math.random());

        if (v === 1) {
          retStr = retStr.replace(new RegExp(x, "g"), obj[x]);
        }
      }
      return retStr;
    }

    function g() {
      let v = Math.round(Math.random());

      if (v === 1) {
        return "e";
      }

      return "f";
    }

    let d = Math.round(new Date().getTime() / 1000);

    let s =
      "0x" +
      cc(a.a, m) +
      g() +
      cc(c, m) +
      g() +
      cc(a.d, m) +
      g() +
      cc(a.c, m) +
      g() +
      cc(a.e, m) +
      g() +
      f +
      g() +
      cc(b.c, m) +
      g() +
      cc(b.e, m) +
      g() +
      cc(d, m);

    // const updatingScoreAlertId = this.showAlert("Updating Leaderboard...")

    let username = window.username();
    let signature = window.signature();

    let response = await fetch("/api/update-score", {
      method: "POST",
      body: JSON.stringify({
        username,
        level,
        score,
        level_status: completed ? "COMPLETED" : "INCOMPLETE",
      }),
      headers: {
        "content-type": "application/json; charset=UTF-8",
        "rpc": s,
        "auth-token": signature,
      },
    });

    // this.hideAlert(updatingScoreAlertId)

    loadScores();
    loadLeaderboardData();

    let responseText = await response.text();
    let responseJson;
    try {
      responseJson = JSON.parse(responseText);
    } catch (e) {
      // console.warn(e)
    }
    if (!responseJson) {
      if (responseText !== "OK") {
        console.log("Error: ", responseText);
        showAlert("Error: " + responseText);
        return false;
      }
    } else if (responseJson.status !== "success") {
      console.log("Error", responseJson.msg);
      showAlert("Error: " + responseJson.msg);
      return false;
    } else {
      // this.showAlert('Leaderboard updated!')
    }

    // console.log({ responseText })

    return true;
  };
  useEffect(() => {
    window.showReactApplication = () => {
      setisGameOn(false);

      document.body.classList.remove("playing-game");
    };

    window.updateScore = (level, score, completed, cat, enemy, ts) => {
      updateScore(level, score, completed, cat, enemy, ts);
    };

    loadLeaderboardData();
  }, []);

  const startGame = async () => {
    if (!signature) {
      // console.log('Connect wallet first!')
      showAlert("Please Connect Wallet first.");
      return;
    }

    if (isAddingUsername) {
      return;
    }

    let usernameAdded = await addUsername();
    console.log("usernameAdded", usernameAdded);
    if (!usernameAdded) return;
    setisGameOn(true);

    if (typeof window.startGameScene === "function") {
      window.startGameScene();
    } else {
      startGame2();

      setTimeout(() => {
        try {
          // console.log('tryRepositioningMobileControls()')
          if (typeof window.repositionControls === "function") {
            window.repositionControls();
          }
        } catch (e) {
          console.warn(e);
        }
      }, 0);
      setTimeout(() => {
        try {
          // console.log('tryRepositioningMobileControls()')
          if (typeof window.repositionControls === "function") {
            window.repositionControls();
          }
        } catch (e) {
          console.warn(e);
        }
      }, 500);
    }
    document.body.classList.add("playing-game");
  };

  const onSuccessLogin = () => {
    refetchPlayer();
  };

  const handleLogout = () => {
    logout();
    refetchPlayer();
  };

  const checkConnection2 = async () => {
    const logout = localStorage.getItem("logout");
    if (logout !== "true") {
      window.web3 = new Web3(window.ethereum);
      await window.web3.eth.getCoinbase().then((data) => {
        if (data) {
          setWallet(data);
          setisConnected(true);
        } else {
          setWallet();
          setisConnected(false);
        }
      });
    } else {
      setisConnected(false);
      setWallet();
    }
  };

  useEffect(() => {
    refetchPlayer();
    // checkConnection2();
  }, []);

  const { ethereum } = window;
  // ethereum?.on("accountsChanged", checkConnection2);

  return (
    <div className="container-fluid" style={{ padding: 0 }}>
      {fireAppcontent === true && <AppContent />}

      {isGameOn ? (
        <MobileGameControls />
      ) : (
        <Menu
          loadScores={loadScores}
          loadLeaderboardData={loadLeaderboardData}
          handleConnectWallet={handleConnectWallet}
          onSelectedLevel={(value) => {
            setselectedLevel(value);
          }}
          onSelectCat={(value) => {
            setselectedCat(value);
          }}
          onGameSoundsOn={(value) => {
            setareGameSoundsOn(value);
          }}
          username={username}
          selectedCat={selectedCat}
          selectedLevel={selectedLevel}
          areGameSoundsOn={areGameSoundsOn}
          lastUnlockedLevel={lastUnlockedLevel}
          leaderboard={leaderboard}
          signature={signature}
          usernameInputDisabled={usernameInputDisabled}
          leaderboardScore={leaderboardScore}
          bestScores={bestScores}
          isGameOn={isGameOn}
          startGame={startGame}
          onSuccessLogin={onSuccessLogin}
          address={data?.getPlayer?.wallet?.publicAddress}
          loadingPlayer={loadingPlayer}
          email={email}
          userId={data?.getPlayer?.playerId}
          wodUsername={data?.getPlayer?.displayName}
          LogoutClick={handleLogout}
          isConnected={isConnected}
          wallet={wallet}
          onWalletLinkComplete={addUsername}
          handleConnect={() => {
            setisBnb(true);
            handleConnectWallet();
          }}
          isSuccess={isBnbSuccess}
          syncStatus={syncStatus}
        />
      )}

      <div
        className="pt-3"
        aria-live="polite"
        aria-atomic="true"
        style={{ position: "fixed", top: 0, right: 0, left: 0, zIndex: 999999 }}
      >
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            id={toast.id}
            message={toast.message}
            onToastHide={hideAlert}
          />
        ))}
      </div>
    </div>
  );
}

export default App;
